import { defineMessages } from "react-intl";
export const messages = defineMessages({
    scanRequestsCompletedSearch: {
        id: "scanRequests.completed.search.placeholder",
        defaultMessage: "Search",
    },
    adminScanRequestsPageTitle: {
        id: "adminScanRequests.layout.page.title",
        defaultMessage: "Scan Requests",
    },
    adminScanRequestsTabRequests: {
        id: "adminScanRequests.layout.tabs.requests",
        defaultMessage: "Requests",
    },
    adminScanRequestsTabCompleted: {
        id: "adminScanRequests.layout.tabs.completed",
        defaultMessage: "Completed",
    },
});
